export const CUSTOM_DECK_CARD_MAX_HEIGHT = 262;
